import React from 'react';

const viewContext = React.createContext({ location: null, match: null, history: null });

export default viewContext;